export default __webpack_public_path__ + "static/media/batch.5629013f.JPG";